import { Center, CenterProps, Loader } from '@mantine/core';

export const Loading = (props: Omit<CenterProps, 'children'>) => {
  return (
    <Center {...props} w="100%">
      <Loader />
    </Center>
  );
};
